import React from 'react'

export const Feature1 = ({header, text, img}) => {
    return (
        <div className='flex lg:gap-[5%] gap-[5%] w-full justify-between'>
            <div className=''>
                <p className='text-white lg:text-[25px] text-[14px] font-semibold lg:text-end text-start'>{header}</p>
                <p className='text-[13px] text-white text-opacity-75 text-end md:text-start'>{text}</p>
            </div>
            <img src={img} alt="" />
        </div>
    )
}
export const Feature2 = ({header, text, img}) => {
    return (
        <div className='flex gap-[5%] '>
            <img src={img} alt="" />
            <div  >
                <p className='text-white lg:text-[25px] text-[14px] font-semibold'>{header}</p>
                <p className='text-[13px] text-white text-opacity-75'>{text}</p>
            </div>
        </div>
    )
}



